if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.swiperEl = this.querySelector('.swiper');
        this.swiper = null;
      }

      show(opener, slideIndex = 0) {
        super.show(opener , slideIndex);
        this.resetZoom();
        this.activateSlide(opener);
      }

      hide() {
        this.resetZoom();
        super.hide();
      }

      resetZoom() {
        if (!this.swiper || !this.swiper.zoom) return;

        // Reset zoom via Swiper API
        this.swiper.zoom.out();

        // Also clear any inline transforms on zoom targets
        this.swiper.slides.forEach((slide) => {
          const zoomTarget =
            slide.querySelector('.swiper-zoom-container') ||
            slide.querySelector('img');
          if (zoomTarget && zoomTarget.style) {
            zoomTarget.style.transform = '';
          }
        });
      }

      activateSlide(opener) {
        const mediaId =
          opener?.getAttribute('data-media-id') ||
          opener?.closest?.('modal-opener')?.getAttribute('data-media-id');

        // Initialize Swiper if not already initialized
        if (!this.swiper && this.swiperEl) {
          // Mark direct children of zoom containers as zoom targets
          // so Swiper finds them for both image and video slides
          this.swiperEl.querySelectorAll('.swiper-zoom-container > *').forEach(el => {
            el.classList.add('swiper-zoom-target');
          });

          this.swiper = new Swiper(this.swiperEl, {
            slidesPerView: 1,
            loop: false,
            speed: 500,
            simulateTouch: true,
            grabCursor: true,
            touchReleaseOnEdges: true,
            loop: true,
            mousewheel: {
              forceToAxis: true,
              sensitivity: 1,
              releaseOnEdges: true
            },
            watchOverflow: true,
            zoom: {
              maxRatio: 3,
              minRatio: 1,
              toggle: false,
            },
            navigation: {
              nextEl: this.swiperEl.querySelector('.swiper-button-next'),
              prevEl: this.swiperEl.querySelector('.swiper-button-prev'),
            },
            pagination: {
              el: this.swiperEl.querySelector('.swiper-pagination'),
              clickable: true,
            },
          });

          // Single-tap zoom toggle — works for both images and videos
          this.swiper.on('tap', (swiper, e) => {
            if (
              e.target.closest('.swiper-button-next') ||
              e.target.closest('.swiper-button-prev') ||
              e.target.closest('.swiper-pagination')
            ) return;

            const zoom = swiper.zoom;
            if (!zoom) return;

            const currentSlide = swiper.slides[swiper.activeIndex];
            const isVideo = !!currentSlide.querySelector('video');

            if (!isVideo) {
              const img = currentSlide.querySelector('img');
              if (!img || !img.complete) return;
            }

            zoom.scale === 1 ? zoom.in() : zoom.out();
          });

          // Reset zoom on slide change
          this.swiper.on('slideChange', () => {
            const zoom = this.swiper.zoom;
            if (zoom && zoom.scale !== 1) zoom.out();
          });
        }

        // Activate slide based on mediaId
        if (this.swiper && mediaId) {
          const slides = [...this.swiperEl.querySelectorAll('.swiper-slide')];
          const index = slides.findIndex((slide) =>
            slide.querySelector('[data-media-id]')?.getAttribute('data-media-id') === mediaId
          );

          if (index > -1) {
            this.swiper.update();
            setTimeout(() => {
              this.swiper.slideTo(index, 0);
              slides[index].querySelector('deferred-media')?.loadContent?.(false);
            }, 0);
          }
        }
      }
    }
  );
}
